import { render } from "./BodyFunctions.vue?vue&type=template&id=fd9dbaec&scoped=true"
import script from "./BodyFunctions.vue?vue&type=script&lang=js"
export * from "./BodyFunctions.vue?vue&type=script&lang=js"

import "./BodyFunctions.vue?vue&type=style&index=0&id=fd9dbaec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd9dbaec"]])

export default __exports__